import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileStatistics = ({ statistics, role }) => {
  const stats = [
    {
      icon: 'Truck',
      label: role === 'owner' ? 'Active Listings' : 'Total Rentals',
      value: role === 'owner' ? statistics?.activeListings || 0 : statistics?.totalRentals || 0,
      color: 'var(--color-primary)'
    },
    {
      icon: 'CheckCircle',
      label: 'Completed Rentals',
      value: statistics?.completedRentals || 0,
      color: 'var(--color-success)'
    },
    {
      icon: 'Star',
      label: 'Average Rating',
      value: statistics?.averageRating || 'N/A',
      color: 'var(--color-accent)',
      suffix: statistics?.averageRating ? ` (${statistics?.totalReviews} reviews)` : ''
    },
    {
      icon: 'Calendar',
      label: 'Member Since',
      value: statistics?.memberSince || 'N/A',
      color: 'var(--color-primary)'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6">
      <h2 className="font-heading text-2xl font-semibold text-foreground mb-6">
        Profile Statistics
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats?.map((stat, index) => (
          <div
            key={index}
            className="bg-background rounded-lg p-6 border border-border hover:shadow-md transition-shadow"
          >
            <div className="flex items-start space-x-4">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={stat?.icon} size={24} color={stat?.color} strokeWidth={2} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-caption text-sm text-muted-foreground mb-1">
                  {stat?.label}
                </p>
                <p className="font-heading text-2xl font-bold text-foreground truncate">
                  {stat?.value}
                </p>
                {stat?.suffix && (
                  <p className="font-body text-xs text-muted-foreground mt-1">
                    {stat?.suffix}
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfileStatistics;